export default "__VITE_ASSET__CzYHXM5i__"